import React, { useState } from "react";

export interface RegistrationResponse {
  allowed: boolean;
  email: string;
  personMetadata: Record<string, unknown>;
  error?: string;
}

interface RegistrationCodeFormProps {
  email: string;
  userId?: string; // Entra User ID (OID) for saving the mapping
  env?: string; // Environment for the mapping (defaults to staging)
  onSuccess: (data: RegistrationResponse) => void;
}

export default function RegistrationCodeForm({ email, userId, env = "staging", onSuccess }: RegistrationCodeFormProps) {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const res = await fetch("/api/registration/validate", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify({
          email,
          registrationCode: code,
          userId, // Pass the Entra User ID to save the mapping
          env // Pass the environment
        })
      });

      const data: RegistrationResponse = await res.json();

      if (!data.allowed) {
        setError(data.error || "Invalid registration code.");
        return;
      }

      onSuccess(data);
    } catch (err) {
      setError("Unexpected error contacting the server.");
      console.error("Registration error:", err);
    } finally {
      setLoading(false);
    }
  }

  return (
    <form onSubmit={submit} className="landing-form">
      <input
        type="text"
        value={code}
        onChange={e => setCode(e.target.value)}
        placeholder="Enter your Personnel ID"
        required
        className="landing-form__input"
      />

      {error && <div className="landing-form__error">{error}</div>}

      <button type="submit" disabled={loading} className="landing-form__submit">
        {loading ? "Validating…" : "Continue"}
      </button>
    </form>
  );
}
